import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, Heading, Separator, Text } from '@chakra-ui/react'

import { useCustomerInfo } from 'hooks/useCustomerInfo'

import { StyledOrganizationDropdown } from './styles'

interface SelectUserOrganizationDropdownProps {
  isOpen: boolean
}

const SelectUserOrganizationDropdown = ({ isOpen }: SelectUserOrganizationDropdownProps): JSX.Element => {
  const { t } = useTranslation(['common', 'cart'])
  const { customerInfo } = useCustomerInfo()

  const organizations = customerInfo.customer?.organizations ?? []

  return (
    <>
      {isOpen && (
        <StyledOrganizationDropdown>
          <Heading as="h3" fontSize="md" fontWeight={400} textAlign="left" lineHeight={{ base: 1.33, md: 1.2 }}>
            {t('user')}
          </Heading>
          <Box key={`userSelect - ${customerInfo.customer?.id}`} display={'flex'} justifyContent={'space-between'}>
            <Text>{customerInfo.customer?.fullName}</Text>
          </Box>

          <Separator />

          {organizations && organizations?.length > 0 && (
            <>
              <Text fontSize="m">{t('organizations')}:</Text>

              {organizations.map((organization, index) => {
                return (
                  <React.Fragment key={`${organization.organizationName} - ${organization.organizationId}`}>
                    {organizations?.length > 1 && index > 0 && <Separator />}
                    <Box
                      key={`${organization.organizationName} - ${organization.organizationId}`}
                      display={'flex'}
                      justifyContent={'space-between'}
                      padding={1}
                    >
                      <Text key={`${organization.organizationName} - ${organization.organizationId}`}>
                        {organization.organizationName}
                      </Text>
                    </Box>
                  </React.Fragment>
                )
              })}
            </>
          )}
        </StyledOrganizationDropdown>
      )}
    </>
  )
}

export default SelectUserOrganizationDropdown
